import script from "./FilmUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilmUploader.vue?vue&type=script&setup=true&lang=ts"

import "./FilmUploader.vue?vue&type=style&index=0&id=4f1646d1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f1646d1"]])

export default __exports__